export default __webpack_public_path__ + "static/media/assign.97e0bb39.svg";